/** Minúsculas y sin tildes: base de toda comparación de texto dictado. */
export function norm(s: string): string {
  return s.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "");
}

/** Separa un dictado en frases (por punto, punto y coma o salto de línea). */
export function frases(texto: string): string[] {
  return texto.split(/(?<=[.;])\s+|\n+/).map((x) => x.trim()).filter(Boolean);
}
